import { connect } from 'react-redux';

import { isInternalUser, isRL, getCurrentUser } from 'store/modules/auth';

const mapStateToProps = state => ({
  isSr: isInternalUser(state),
  isRl: isRL(state),
  user: getCurrentUser(state),
});

export default connect(mapStateToProps);
